module.exports = __webpack_public_path__ + "Timesawardepaper-5d27e217.webp";